// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__uWyZW","success":"Notification_success__xUq9Z","error":"Notification_error__hb4+B"};